import photo1 from './project22-1.png';
import photo2 from './project22-2.png';
import photo3 from './project22-3.png';
import photo4 from './project22-4.png';

const project22 = {
  id: 22,
  name: '북덕(bookduck)',
  team: [
    {
      position: 'FrontEnd Developer',
      names: '이찬희 최영서 최윤진',
    },
    {
      position: 'BackEnd Developer',
      names: '정유정 황혜진 이서현',
    },
    {
      position: 'UXUI Designer',
      names: '외부 협업',
    },
  ],
  about:
    '취향 기반 독서기록서비스, 북덕 🐥 북덕은 서비스명인 ‘덕(Duck)’에서 착안한 귀여운 오리를 메인 캐릭터로, 독서 취향을 즐겁게 시각화합니다. 독서 기록을 통해 얻을 수 있는 아이템으로 나만의 캐릭터를 꾸미고, 북덕이 분석한 독서 리포트를 통해 나의 독서 패턴을 살펴볼 수 있습니다. 완성한 캐릭터와 독서 리포트, 마음에 드는 기록 카드를 SNS에 공유하며 새로운 북토크를 열어보세요!',
  links: {
    website: 'https://bookduck.vercel.app/login',
    github: 'https://github.com/MoneyMakersClub',
  },
  photos: [photo1, photo2, photo3, photo4],
};

export default project22;
